import script from "./ServicesManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesManagement.vue?vue&type=script&setup=true&lang=js"

import "./ServicesManagement.vue?vue&type=style&index=0&id=25aa95fa&lang=css"

const __exports__ = script;

export default __exports__